import { render, staticRenderFns } from "./ClientAssociatedResourceTabs.vue?vue&type=template&id=d5626920&scoped=true&"
import script from "./ClientAssociatedResourceTabs.vue?vue&type=script&lang=js&"
export * from "./ClientAssociatedResourceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5626920",
  null
  
)

export default component.exports